import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

interface Props {
  children: React.ReactNode;
}

/**
 * 全局会话守卫。包裹需要登录的后台壳层(AppShell 分支)。
 *
 * 背景:`/admin/session` 401 时,AuthProvider 把 role/user 退化为 null,
 * 而非 dev-mock 模式(出厂/prod)下没有有效会话就是这种状态。若不拦截,
 * AppShell 会照常渲染,只是 WorkspaceSideNav 把按角色门控的导航项全过滤掉——
 * 用户看到"导航凭空消失"的破损页,完全意识不到只是没登录。
 *
 * 行为:
 *   - 会话加载中(isLoading)→ 返回 null,避免登录态确定前误跳。
 *   - 无 user(401 / 会话失效)→ 重定向 /login,并用 state.from 记录来源路径。
 *   - 有 user → 放行。
 *
 * /login 等公开路由在本守卫之外(见 routes.tsx 的 FirstRunGate 直接子路由),
 * 不会形成重定向回环。
 */
export function RequireAuth({ children }: Props) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return null;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
